'use client';
import PropTypes from 'prop-types';
import * as React from 'react';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
import { Button } from '../button/button.component.js';
import { Icon } from '../icon/icon.component.js';

const propTypes = {
    /**
   * Provide the text that should be used for screen readers.
   */ accessibleText: PropTypes.string
};
const propKeysToRemove = [
    'accessibleText'
];
/**
 * @subcomponent PriceBar
 */ const PriceBarPriceInfo = renderWithRef('PriceBarPriceInfo', propTypes, (props, ref)=>{
    const classNames = new Set([
        'swan-price-bar-price-info'
    ]);
    return /*#__PURE__*/ React.createElement(RenderComp, {
        root: "div",
        forwardedRef: ref,
        classNames: classNames,
        props: props,
        propKeysToRemove: propKeysToRemove
    }, /*#__PURE__*/ React.createElement(Button, {
        skin: "unstyled"
    }, /*#__PURE__*/ React.createElement(Icon, {
        alt: props.accessibleText || '',
        iconType: "info",
        size: "standard"
    })));
});

export { PriceBarPriceInfo };
